





















































































import { Component, Vue } from 'vue-property-decorator'
import { isXcxWeb } from '@ivy/fts/utils'
import { env } from '@ivy/fts/envInfo/envInfo'

@Component({
  components: {
    CustomerButton: () => import('@ivy/fts/comps/Customer'),
  },
})
export default class MyLogistics extends Vue {
  isXcxWeb = isXcxWeb()
  count: number = 0
  data: any[] = []
  selectIndex: number = 0
  statusMap = {
    [-1]: '待发货',
    0: '已发货',
    1: '运输中',
    2: '正在派件',
    3: '已签收',
    4: '派送失败',
    5: '疑难件',
    6: '退件签收',
  }
  iconMap = {
    [-1]: 'wait',
    0: 'shipped',
    1: 'transit',
    2: 'sending',
    3: 'already',
    4: 'sending-rror',
    5: 'problem',
    6: 'return',
  }
  get iconSrc() {
    return s => {
      return this.iconMap[s]
        ? require(`@/assets/order/${this.iconMap[s]}.png`)
        : ''
    }
  }
  get active() {
    return num => {
      return this.selectIndex + 1 === num ? 'active' : ''
    }
  }
  get expressList() {
    return (this.data[this.selectIndex] || {}).express_list || []
  }
  get material() {
    return (this.data[this.selectIndex] || {}).express_list || []
  }
  get imgSrc() {
    return (good, item) => {
      let m_src = item.material ? item.material.material_img : ''
      let g_src = good.good_img
      return m_src || g_src || ''
    }
  }
  get hasMaterial() {
    return item => {
      return item.material ? Object.keys(item.material).length > 0 : false
    }
  }
  async created() {
    this.$title('物流信息')
    await env.init()
    let isLogin = await env.getIsLogin()
    if (!isLogin) {
      return await env.login()
    }
    let { tid, expressNum, barcode } = this.$route.query
    let conf = {
      disableAlert: true,
    }
    let { data } = await this.$axios.get(
      '/api/goods/shop/search/delivery/getCycleExpressList',
      {
        params: {
          tid,
          barcode,
        },
        ...conf,
      }
    )
    this.count = data.cycle_deliver_total || 0
    this.data = data.cycle_deliver_list || []
    console.log(data.cycle_deliver_list)
  }
  selectedExpress(num) {
    this.selectIndex = num - 1
  }
  toDetail(item) {
    if (item.delivery_status === -1) {
      this.$Toast('暂无物流信息')
      return
    }
    this.$router.push({
      // path: 'orderLogistics',
      path: 'orderTracking',
      query: {
        expressNum: item.express_num,
        tid: this.$route.query.tid,
      },
    })
  }
  copy(code) {
    let oInput = document.createElement('input')
    oInput.value = code
    oInput.style.position = 'absolute'
    oInput.style.top = '-999px'
    document.body.appendChild(oInput)
    oInput.select()
    document.execCommand('copy')
    oInput.remove()
    this.$Toast('复制成功 ')
  }
}
